/* eslint-disable no-useless-constructor */
import FieldModel from './FieldModel';
import { TextAreaInput } from '../inputs';
import { verifyMultiEmail } from '../../../../juristec-ui/utils/validators/inputTextValidators';

class MultiEmailField extends FieldModel {
  /**
   * @param {Object} params
   * @param {string} params.kWord Unique object key (from plans)
   * @param {string} params.label Input label, used on the field filter
   * @param {boolean} [params.required] If the input is required (not empty)
   * @param {boolean} [params.removed] Condition to not render and use this field
   * @param {boolean} [params.disabled] Condition to block this field (still visible)
   * @param {any} [params.default] Default (initial) value
   * @param {number} params.min Minimum number of emails
   * @param {functtion} params.maxFunc Function to get the maximum number of emails
   */
  constructor(params) {
    super(params);
  }

  getDefaultState = () => ({
    value: '',
    formatedValue: [],
    error: Boolean(this.required),
    errorMsg: this.required ? 'Informe emails válidos' : '',
  });

  genFormatedState = (value) => (
    value ? {
      value: value.join('\n'),
      formatedValue: value.filter((t) => t),
      error: false,
      errorMsg: '',
    } : null
  );

  handleInput = (e, handle, state) => {
    const val = e.target.value;
    const emails = val.split('\n').map((v) => v.trim());
    const msg = verifyMultiEmail(new Set(emails.filter((t) => t)), this.min, this.maxFunc(state));
    handle({
      [this.kWord]: {
        value: emails.join('\n'),
        formatedValue: emails.filter((t) => t),
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  }

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (e) => this.handleInput(e, handle, state);
    return (
      <TextAreaInput
        label={this.label}
        placeholder="um email por linha..."
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  }
}

export default MultiEmailField;
